module.exports = __webpack_public_path__ + "img/grandex-white.a6adba89.svg";